import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { getOrderedProgramRequests } from "../services/goHireService";

const REQUESTS_PAGE_LIMIT = 3;

interface UseProgramRequestsParams {
  limit?: number;
  offset?: number;
  sort?: Record<string, "ASC" | "DESC">;
  enabled?: boolean;
}

interface UseProgramRequestsPaginatedParams extends UseProgramRequestsParams {
  page?: number;
}

export const useOrderedProgramRequestsPaginated = ({
  limit = REQUESTS_PAGE_LIMIT,
  page = 0,
  sort,
  enabled,
}: UseProgramRequestsPaginatedParams = {}) => {
  return useQuery({
    queryKey: [...GO_SERVICE_QUERY_KEYS.orderedProgramRequests(), { limit, page, sort }],
    queryFn: () => getOrderedProgramRequests({ limit, offset: page * limit, sort }),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: enabled,
  });
};

export const useOrderedProgramRequestsInfinite = ({
  limit = REQUESTS_PAGE_LIMIT,

  sort,
  enabled,
}: Omit<UseProgramRequestsParams, "offset"> = {}) => {
  return useInfiniteQuery({
    queryKey: [...GO_SERVICE_QUERY_KEYS.orderedProgramRequests(), { limit, sort }],
    queryFn: ({ pageParam = 0 }) => getOrderedProgramRequests({ limit, offset: pageParam * limit, sort }),
    getNextPageParam: (lastPage, allPages) => {
      const fetchedCount = allPages.length * limit;
      return fetchedCount < lastPage.data.meta.totalItems ? allPages.length : undefined;
    },
    initialPageParam: 0,
    enabled: enabled,
  });
};
